module.exports = __webpack_public_path__ + "img/ArgIslan4.f8a0be6a.jpg";